import { Observable, of } from 'rxjs'

import { Record, RecordFeatured } from '@skinsoft/types'
import { recordSelectors } from '@skinsoft/selectors'

export function toRecordFeatured$(record: Record, locale: string): Observable<RecordFeatured> {
    const featuredrecord: RecordFeatured = {
        // recordSelectors.currentState can resolve to undefined at runtime (missing workflow state), but RecordFeatured models it as always present
        currentState: recordSelectors.currentState(record, locale) as string,
        fromUpdateCache: !!record.fromUpdateCache,
        id: recordSelectors.id(record),
        // @ts-ignore
        linkedItemId: recordSelectors.linkedItemId(record),
        // @ts-ignore
        recordIdentifier: recordSelectors.recordIdentifier(record),
        linkedItemIdentifier: recordSelectors._linkedItemInventoryNumber(record),
        linkedItemType: recordSelectors._linkedItemType(record),
        currentLocationId: recordSelectors.currentLocationId(record)
    }

    return of(featuredrecord)
}